import { api } from "./api";

export const fieldForceListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/view-users`, { params });
};

export const fieldForceDetailApi = (params) => {
  return api.get(`/manufacturer/field-force-user/view-user`, {
    params: params,
  });
};
export const fieldForceAdminOverrideApi = (params) => {
  return api.post(`/manufacturer/field-force-user/admin/over-ride-toggle`, {
    params: params,
  });
};

export const fieldForceDeleteApi = (params) => {
  return api.delete(`/manufacturer/field-force-user/delete-user`, {
    data: params,
  });
};

export const fieldForceEnableDisableApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/enable-disable`,
    JSON.stringify(params)
  );
};

export const fieldForceCreateApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/create`,
    JSON.stringify(params)
  );
};

export const fieldForceEditApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/edit`,
    JSON.stringify(params)
  );
};

export const fieldForceVersionList = (params) => {
  return api.get(`/manufacturer/field-force-user/view-versions`, {
    params: params,
  });
};

export const fieldForceVersionDetail = (params) => {
  return api.get(`/manufacturer/field-force-user/view-user-version`, {
    params: params,
  });
};

export const fieldForceDesignationListApi = (params) => {
  return api.get(`manufacturer/field-force-user/designation-list`);
};

export const reportingManagerListApi = (params) => {
  return api.get(`manufacturer/field-force-user/reporting-manager`, {
    params: params,
  });
};

export const headQuaterListApi = (params) => {
  return api.get(`manufacturer/field-force-user/head-quaters-list`);
};

export const fetchDesignationListApi = (params) => {
  return api.get(`/manufacturer/field-force-designation/view-all`, {
    params: params,
  });
};
export const fetchDesignationDetailApi = (params) => {
  return api.get(`/manufacturer/field-force-designation/view-designation`, {
    params: params,
  });
};

export const fieldForceDesignationCreateApi = (params) => {
  return api.post(
    `/manufacturer/field-force-designation/create`,
    JSON.stringify(params)
  );
};

export const fieldForceDesignationEditApi = (params) => {
  return api.post(
    `/manufacturer/field-force-designation/edit-designation
  `,
    JSON.stringify(params)
  );
};

export const fieldForceDesignationDeleteApi = (params) => {
  return api.delete(
    `/manufacturer/field-force-designation/delete-designation
  `,
    {
      data: params,
    }
  );
};

export const fieldForceDesignationVersionList = (params) => {
  return api.get(
    `/manufacturer/field-force-designation/designations-versions`,
    {
      params: params,
    }
  );
};

export const fieldForceDesignationVersionDetail = (params) => {
  return api.get(`/manufacturer/field-force-designation/view-version`, {
    params: params,
  });
};

export const fieldForceLinkEmpListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/link-employee-ids-list`, {
    params: params,
  });
};

export const fieldForceLinkEmployeeApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/link-employee`,
    JSON.stringify(params)
  );
};

export const fieldForceHeadQuarterListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/head-quarters/list`, {
    params,
  });
};
export const fieldForceHeadQuarterDetailApi = (params) => {
  return api.get(`/manufacturer/field-force-user/head-quarters/view`, {
    params: params,
  });
};
export const fieldForceHeadQuarterCreateApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/head-quarters/create`,
    JSON.stringify(params)
  );
};
export const fieldForceHeadQuarterEditApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/head-quarters/edit`,
    JSON.stringify(params)
  );
};
export const fieldForceHeadQuarterVersionListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/head-quarters/version-list`, {
    params,
  });
};
export const fieldForceHeadQuarterVersionDetail = (params) => {
  return api.get(`/manufacturer/field-force-user/head-quarters/version-view`, {
    params: params,
  });
};
export const headQuarterEnableDisableApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/head-quarters/enable-disable`,
    JSON.stringify(params)
  );
};
export const headQuarterDeleteApi = (params) => {
  return api.delete(`/manufacturer/field-force-user/head-quarters/delete`, {
    data: params,
  });
};
export const fieldForceAdminViewApi = (params) => {
  return api.get(`/manufacturer/field-force-user/admin`, { params });
};
export const fieldForceAdminVerifyApi = (params) => {
  return api.get(`/manufacturer/field-force-user/admin/verify`, {
    params: params,
  });
};

export const fieldForceAdminEditApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/admin/save`,
    JSON.stringify(params)
  );
};
export const reportingDesignationListApi = (params) => {
  return api.get(
    `/manufacturer/field-force-designation/reporting-designation`,
    {
      params: params,
    }
  );
};
export const subordinatesListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/view-subordinates`, {
    params,
  });
};
export const repostingManagesListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/list-of-hq-based-fflist`, {
    params,
  });
};
export const updatingSubordinatesRepostingManagesApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/update-subordinates-reporting-manager`,
    JSON.stringify(params)
  );
};
export const updatingCustomersRepostingManagesApi = (params) => {
  return api.post(
    `/manufacturer/field-force-user/customer-reassign`,
    JSON.stringify(params)
  );
};
export const ffCustomersListApi = (params) => {
  return api.get(`/manufacturer/field-force-user/fieldForce-customers`, {
    params,
  });
};
